import React from 'react';

const Receipt = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 7C2 5.89543 2.89543 5 4 5H15.0801C15.664 5 16.2187 5.25513 16.5986 5.69842L20.8844 10.6984C21.5263 11.4474 21.5263 12.5526 20.8844 13.3016L16.5986 18.3016C16.2187 18.7449 15.664 19 15.0801 19H4C2.89543 19 2 18.1046 2 17V7Z"
        stroke="#787F88"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 13C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11C14.4477 11 14 11.4477 14 12C14 12.5523 14.4477 13 15 13Z"
        stroke="#787F88"
        strokeWidth="2"
      />
    </svg>
  );
};

export default Receipt;
